import React, { Fragment, useState, useEffect } from "react";

import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
// import styled from "styled-components";
// import { Btc, Eth, Ltc, Doge, Xrp, Bnb } from "@styled-icons/crypto";
import {
  BlockchainName,
  DepositMethods,
  DepositMethodAndUserBalance,
  UserBalances,
  DevType,
} from "../../typings";
import { capitalizeFirstLetter, formatCryptoDecimals } from "../../utils/misc";

// const BtcIcon = styled(Btc)`
//   color: orange;
// `;
// const EthIcon = styled(Eth)`
//   color: blue;
// `;
// const LtcIcon = styled(Ltc)`
//   color: gray;
// `;
// const DogeIcon = styled(Doge)`
//   color: gold;
// `;
// const XrpIcon = styled(Xrp)`
//   color: black;
// `;
// const BnbIcon = styled(Bnb)`
//   color: gold;
// `;

type Args = {
  depositMethods: DepositMethods;
  onChange: any;
  userBalances: UserBalances;
  preSelectedblockchainName: BlockchainName | "";
  type: DevType;
};

type DepositMethodsAndUserBalances = DepositMethodAndUserBalance[];
export default function ({
  depositMethods,
  onChange,
  userBalances,
  preSelectedblockchainName,
  type,
}: Args) {
  //TODO: change name of deposit method to something else
  const [selectedBlockchainName, setSelectedBlockchainName] = useState<
    BlockchainName | ""
  >(preSelectedblockchainName);
  const [depositMethodsAndUserBalances, setDepositMethodsAndUserBalances] =
    useState<DepositMethodsAndUserBalances>([]);
  const [
    selectedDepositMethodAndUserBalance,
    setSelectedDepositMethodAndUserBalance,
  ] = useState<DepositMethodAndUserBalance | null>(null);

  function mergeDepositMethodsAndUserBalances() {
    const newDepositMethodsAndUserBalances: DepositMethodsAndUserBalances = [];
    for (const depositMethod of depositMethods) {
      const userBalance = userBalances.find(
        (userBalance) =>
          userBalance.blockchainName === depositMethod.blockchain.name
      );

      if (!userBalance) {
        newDepositMethodsAndUserBalances.push({
          ...depositMethod,
          fiat: { usd: "0" },
          value: "0",
        });
        continue;
      }

      newDepositMethodsAndUserBalances.push({
        ...depositMethod,
        fiat: userBalance.fiat,
        value: userBalance.value,
      });
    }

    if (newDepositMethodsAndUserBalances.length) {
      const depositMethod = newDepositMethodsAndUserBalances.find(
        (depositMethod) =>
          depositMethod.blockchain.name === selectedBlockchainName
      );
      if (depositMethod) {
        setSelectedDepositMethodAndUserBalance(depositMethod);
      }
    }
    setDepositMethodsAndUserBalances(newDepositMethodsAndUserBalances);
  }

  function updateState() {
    // console.log("withdraw dropdown userBalances:", userBalances);
    if (depositMethods.length) {
      setSelectedBlockchainName(depositMethods[0].blockchain.name);
    }
    mergeDepositMethodsAndUserBalances();
  }

  useEffect(() => {
    updateState();
  }, []);

  useEffect(() => {
    updateState();
  }, [depositMethods, userBalances]);

  useEffect(() => {
    onChange(selectedBlockchainName);
  }, [selectedBlockchainName]);

  function ButtonText() {
    if (selectedDepositMethodAndUserBalance === null) {
      return <span>No withdraw method found</span>;
    }

    return (
      <Fragment>
        <img
          className="w-4 h-4 mr-2"
          src={selectedDepositMethodAndUserBalance.symbolIcon}
          alt={selectedDepositMethodAndUserBalance.blockchain.symbol}
        />{" "}
        {capitalizeFirstLetter(selectedBlockchainName)}
        <ChevronDownIcon
          className="ml-2 -mr-1 h-5 w-5 text-violet-200 hover:text-violet-100"
          aria-hidden="true"
        />
      </Fragment>
    );
  }
  return (
    <Fragment>
      <div className="flex justify-center">
        <Menu as="div" className="relative inline-block text-left">
          <div>
            <Menu.Button className="overflow-visible inline-flex w-full rounded-md justify-center items-center bg-blue-600 px-4 py-2 text-sm font-medium text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
              <ButtonText />
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute overflow-visible mt-2 w-80 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="px-1 py-1 w-full text-center text-sm font-medium">
                Crypto {capitalizeFirstLetter(type)} Mode
              </div>
              {depositMethodsAndUserBalances.map((depositMethod) => {
                return (
                  <Menu.Item key={depositMethod.blockchain.name}>
                    <div
                      className="flex justify-between p-3"
                      onClick={() =>
                        setSelectedBlockchainName(depositMethod.blockchain.name)
                      }
                    >
                      <div className="flex justify-between w-full">
                        <span className="text-blue-700 text-sm font-medium ml-5 w-2/5">
                          {formatCryptoDecimals(depositMethod.value)}
                        </span>
                        <div className="flex w-3/5">
                          <img
                            className="w-6 h-6"
                            src={depositMethod.symbolIcon}
                            alt={depositMethod.blockchain.symbol}
                          />
                          <p className="text-sm font-medium ml-3">
                            {depositMethod.symbol.toUpperCase()} (
                            {depositMethod.blockchain.name.toUpperCase()})
                          </p>
                        </div>
                      </div>
                    </div>
                  </Menu.Item>
                );
              })}
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </Fragment>
  );
}
